<script>
  import Confirmation from '@/components/widgets/modals/Confirmation'
  import deviceConfig from './config/vss-dms-device-config.json'
  import * as vssConfiguration from '@/services/rest-api-sms/lib/vss-configuration/vss-configuration'
  import { numChannelMap } from '@/router/views/qcdevice/vssConfiguration/lib/vssconfiguration'

  export default {
    components: { Confirmation },
    props: {
      modal: { type: Boolean, default: false },
      isLoading: { type: Boolean, default: false },
      region: { type: String, default: 'SG' },
      dmsInitialValue: { type: Object, default: null },
      dmsDefaultValue: { type: Object, default: null },
      deviceType: { type: String, default: '12004' },
      initialProfile: { type: Object, default: null },
    },
    data() {
      return {
        modalConfirm: false,
        modalUnsavedConfirm: false,
        linkageModal: false,
        activeRowIndex: null,
        originalFormData: null,
        filteredProfiles: [],
        defaultProfile: {
          id: 0,
          profile_name: 'Custom'
        },
        linkageForm: {
          start_record: true,
          voice_broadcast: true,
          preview_mode: 'Model2',
          video_lock: [],
          video_upload: [],
          link_output: false,
          snapshot_upload: [],
          TimeOut1: 10,
          preview: [],
        },
        previewModeOptions: [
          { id: 'Model0', name: 'Model1' },
          { id: 'Model1', name: 'Model2' },
          { id: 'Model2', name: 'Model3' },
          { id: 'Model3', name: 'Model4' },
        ],
        fields: [
          { key: 'type', label: 'Type' },
          { key: 'state', label: 'State' },
          { key: 'threshold', label: 'Threshold (s)' },
          { key: 'interval', label: 'Interval (s)' },
          { key: 'pre_record', label: 'Alarm pre-recording (s)' },
          { key: 'alarm_trigger', label: 'Alarm trigger hold time' },
          { key: 'keeptime', label: 'Duty Cycle' },
          { key: 'alarm_linkage', label: 'Alarm Linkage' },
        ],
        stateOptions: [
          { id: 1, name: 'Enable' },
          { id: 0, name: 'Close' },
        ],
        channelOptions: Array.from({ length: 12 }, (_, i) => ({
          id: `CH${i + 1}`,
          name: `CH${i + 1}`,
        })),
        installOptions: [
          { id: 'default', name: 'Default', key: "0" },
          { id: 'left', name: 'Left', key: "1" },
          { id: 'right', name: 'Right', key: "2" },
        ],
        angleOptions: [
          { id: 0, name: 'Manual' },
          { id: 2, name: 'Value calibrated during installation' },
        ],
        aiFrameOptions: [
          { id: 0, name: 'Close' },
          { id: 1, name: 'Enable' },
        ],
        installSelfCheckOptions: [
          { id: 1, name: 'Enable' },
          { id: 0, name: 'Disable' },
        ],
        form: {
          profile: {
            id: 0,
            profile_name: 'Custom'
          },
          profile_name: '', // for log purpose
          video_channel: 'CH3',
          installation: 'default',
          distraction_angle: 0,
          draw_en: 0,
          installSelfCheck: 0,
          yaw_right: 0,
          yaw_left: 0,
          pitch_down: 0,
          pitch_up: 0,
          rows: [
            { key: 'call', type: 'Call', state: 0, threshold: 15, interval: 30, pre_record: 5, alarm_trigger: 0.5, keeptime: 50 },
            { key: 'smoking', type: 'Smoking', state: 0, threshold: 15, interval: 30, pre_record: 5, alarm_trigger: 0.5, keeptime: 50 },
            { key: 'eyes_closed', type: 'Eyes closed', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50 },
            { key: 'close_eys_serious', type: 'Severe Eye Closure', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50 },
            { key: 'yawning', type: 'Yawning', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50 },
            { key: 'yawn_serious', type: 'Severe Yawning', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50 },
            { key: 'distracted', type: 'Distracted Driving', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50 },
            { key: 'no_driver', type: 'No driver', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50 },
            { key: 'infrared', type: 'Infrared blocking sunglasses', state: 0, threshold: 15, interval: 60, pre_record: 5, alarm_trigger: 0.5, keeptime: 50 },
            { key: 'seat_belt', type: 'Seat belt not fastened', state: 0, threshold: 0, interval: 0, pre_record: 0, alarm_trigger: 0.5, keeptime: 50 },
            { key: 'camera_cover', type: 'Camera Cover', state: 0, threshold: 15, interval: 60, pre_record: 5, alarm_trigger: 0.5, keeptime: 50 },
            { key: 'fatigue_driving', type: 'Fatigue Driving', state: 0, threshold: 15, interval: 60, pre_record: 5, alarm_trigger: 0.5, keeptime: 50 },
          ],
        },
        channelMap: {
          CH1: 1,
          CH2: 2,
          CH3: 4,
          CH4: 8,
          CH5: 16,
          CH6: 32,
          CH7: 64,
          CH8: 128,
          CH9: 256,
          CH10: 512,
          CH11: 1024,
          CH12: 2048,
        }
      }
    },
    computed: {
      showModal: {
        get() { return this.modal }
      },
      loading: {
        get() { return this.isLoading },
        set(v) { this.$emit('update:isLoading', v) },
      },
      currentDeviceConfig() {
        return deviceConfig[this.deviceType] || {}
      },
    },
    methods: {
      hasUnsavedChanges() {
        if (!this.originalFormData) return false
        return JSON.stringify(this.form) !== JSON.stringify(this.originalFormData)
      },
      saveOriginalFormData() {
        this.originalFormData = JSON.parse(JSON.stringify(this.form))
      },
      closeModalWithoutSaving() {
        this.modalUnsavedConfirm = false
        this.resetToDefaultValue()
        this.$emit('update:modal', false)
      },
      saveAndCloseModal() {
        this.modalUnsavedConfirm = false
        this.openConfirm()
      },
      closeModal() {
          if (this.hasUnsavedChanges()) {
            this.modalUnsavedConfirm = true
          } else {
            this.$emit('update:modal', false)
          }
      },
      resetToDefaultValue() {
        this.form = this.originalFormData
      },
      async getProfiles() {
        const params = {
          filters: ["type eq 'dms'", `device_code eq ${this.deviceType}`],
          limit: 99999999999,
          page: 1,
          sorts: ['created_at desc']
        }

        const response = await vssConfiguration.get(params)
        this.filteredProfiles = [this.defaultProfile, ...response?.data?.paginated_result]
        const currentProfile = this.filteredProfiles.find(
          (profile) => 
            profile.id === Number(this.initialProfile?.status_text ?? 0) 
        )
        
        this.form.profile = currentProfile ?? this.defaultProfile
        this.form.profile_name = currentProfile?.profile_name ?? 'Custom'
      },
      selectProfile(profileId) {
        const selectedProfile = this.filteredProfiles.find(
          p => p.id === profileId
        ) || null

        this.form.profile_name = selectedProfile.profile_name ?? 'Custom'
 
        const defaultData = selectedProfile
        if (!defaultData) return

        // Reset video channel
        if (defaultData.chn) {
          this.form.video_channel = numChannelMap[defaultData.chn] || 'CH3'
        }

        // Reset installation from props
        if (defaultData.installation !== undefined && defaultData.installation !== null) {
          const installMap = { 0: 'default', 1: 'left', 2: 'right' }
          this.form.installation = installMap[defaultData.installation] || 'default'
        }

        this.form.distraction_angle = defaultData.i_manual_set ?? 0
        this.form.draw_en = Number(defaultData.draw_en ?? 0)
        this.form.installSelfCheck = Number(defaultData.install_self_check ?? 0)
        this.form.yaw_right = Number(defaultData.yaw_right ?? 0)
        this.form.yaw_left = Number(defaultData.yaw_left ?? 0)
        this.form.pitch_down = Number(defaultData.pitch_down ?? 0)
        this.form.pitch_up = Number(defaultData.pitch_up ?? 0)

        // Reset alarm settings from default values
        if (defaultData.alarm_settings && Array.isArray(defaultData.alarm_settings)) {
          const alarmTypeMap = {
            'call': 'call',
            'smoke': 'smoking',
            'close_eyes': 'eyes_closed',
            'close_eys_serious': 'close_eys_serious',
            'yawn': 'yawning',
            'yawn_serious': 'yawn_serious',
            'distract_driving': 'distracted',
            'driver_abnormal': 'no_driver',
            'ir_blocking': 'infrared',
            'seatbelt_unfastened': 'seat_belt',
            'lens_covered': 'camera_cover',
            'fatigue_driving':'fatigue_driving'
          }

          this.form.rows = this.form.rows.map((row) => {
            const matchingAlarm = defaultData.alarm_settings.find(alarm => 
              alarmTypeMap[alarm.type] === row.key
            )
            
            if (matchingAlarm) {
              return {
                ...row,
                state: matchingAlarm.state ?? 0,
                threshold: matchingAlarm.threshold ?? row.threshold,
                interval: matchingAlarm.interval ?? row.interval,
                keeptime: matchingAlarm.keeptime ?? row.keeptime,
                pre_record: matchingAlarm.alm_triger_pre_recording ?? row.pre_record,
                alarm_trigger: matchingAlarm.alm_triger_hold_time ?? row.alarm_trigger,
                linkage: {
                  start_record: matchingAlarm.record,
                  voice_broadcast: matchingAlarm.link_buzzer,
                  preview_mode: this.codeToPreviewMode(matchingAlarm.link_preview_mode),
                  video_lock: this.maskToChannels(matchingAlarm.link_lock_chn ?? 0),
                  video_upload: this.maskToChannels(matchingAlarm.link_video_upload_chn ?? 0),
                  link_output: matchingAlarm.link_output === 1,
                  snapshot_upload: this.maskToChannels(matchingAlarm.link_snap_chn ?? 0),
                  TimeOut1: String(matchingAlarm.out1_time ?? 10),
                  preview: this.maskToChannels(matchingAlarm.link_preview_chn ?? 0),
                }
              }
            }
            return row
          })
        }
      },
      openConfirm() { this.modalConfirm = true },
      afterConfirm() {
        const chn = (this.form.video_channel || 'CH3').replace(/[^0-9]/g, '') || '3'

        const toStr = (v) => (v === undefined || v === null ? '' : String(v))
        const boolTo01 = (v) => (v ? 1 : 0)
        const rowByKey = (key) => this.form.rows.find((r) => r.key === key) || {}
        const channelsToMask = (arr = []) => {
          return String((arr || []).reduce((m, ch) => m | (this.channelMap[ch] || 0), 0))
        }
        const previewModeToCode = (mode) => {
          const match = mode.match(/^Model(\d+)$/)
          return match ? String(Number(match[1])) : '0'
        }
        const buildAlarm = (row = {}) => {
          const lg = row?.linkage || {}
          return {
            enable: String(row.state) === '1' ? '1' : '0',
            limit: toStr(row.threshold ?? row.limit ?? ''),
            delay: toStr(row.interval ?? ''),
            holdtime: toStr(row.pre_record ?? ''),
            AlmTrigerHoldTime: toStr(row.alarm_trigger ?? '0.5'),
            record: toStr(lg.start_record ?? 0),
            linkBuzzer: toStr(lg.voice_broadcast ?? 0),
            linkPreviewMode: previewModeToCode(lg.preview_mode ?? 'Model2'),
            linkLockChn: channelsToMask(lg.video_lock || []),
            linkUploadChn: channelsToMask(lg.video_upload || []),
            linkOutput: boolTo01(!!lg.link_output),
            linkSnapChn: channelsToMask(lg.snapshot_upload || []),
            PreviewChn: channelsToMask(lg.preview || []),
            keeptime: String(row.keeptime), 
            TimeOut1: lg.TimeOut1
          }
        }

        const call = buildAlarm(rowByKey('call'))
        const smoke = buildAlarm(rowByKey('smoking'))
        const closeEyes = buildAlarm(rowByKey('eyes_closed'))
        const closeEyesSerious = buildAlarm(rowByKey('close_eys_serious'))
        const yawn = buildAlarm(rowByKey('yawning'))
        const yawnSerious = buildAlarm(rowByKey('yawn_serious'))
        const distract = buildAlarm(rowByKey('distracted'))
        const noDriver = buildAlarm(rowByKey('no_driver'))
        const irBlock = buildAlarm(rowByKey('infrared'))
        const seatbelt = buildAlarm(rowByKey('seat_belt'), { record: '0' })
        const lensCovered = buildAlarm(rowByKey('camera_cover'))
        const fatigueDriving = buildAlarm(rowByKey('fatigue_driving'))
        const dir = this.installOptions.find((o) => o.id === this.form.installation)
        
        const DMS = {
          profile_id: this.form.profile.id ?? this.form.profile,
          chn,
          dir: dir.key ?? '0',
          iManulSet: toStr(this.form.distraction_angle ?? 0),
          YawLeft: toStr(this.form.yaw_left ?? 0),
          YawRight: toStr(this.form.yaw_right ?? 0),
          PitchUp: toStr(this.form.pitch_up ?? 0),
          PitchDown: toStr(this.form.pitch_down ?? 0),
          drawEn: toStr(this.form.draw_en ?? 0),
          installSelfCheck: toStr(this.form.installSelfCheck ?? 0),


          call_alarm: call,

          smoke_alarm: smoke,

          close_eys_alarm: closeEyes,

          close_eys_serious_alarm: closeEyesSerious,

          yawn_alarm: yawn,

          yawn_serious_alarm: yawnSerious,

          distract_driving_alarm: distract,

          driver_abnormal_alarm: noDriver,

          ir_blocking_alarm: irBlock,

          seatbelt_unfastened_alarm: seatbelt,

          lens_covered_alarm: lensCovered,
          
          fatigue_driving_alarm: fatigueDriving,
        }

        this.$emit('beforeSubmit', { type: 'DMS', DMS, changes: this.getChangedFields() })
        this.$emit('update:modal', false)
      },
      onlyNumber(evt) {
        const c = String.fromCharCode(evt.which)
        if (!/[0-9]/.test(c)) evt.preventDefault()
      },
      async initFromInitial() {
        await this.getProfiles()
        this.saveOriginalFormData()
        const D = this.dmsInitialValue
        if (!D) {
          return
        } 
        if (D.chn) this.form.video_channel = `CH${String(D.chn).replace(/[^0-9]/g, '')}`

        const installation = this.installOptions.find((o) => o.key === D.dir)
        this.form.installation = installation.id

        this.form.distraction_angle = Number(D.iManulSet)
        this.form.yaw_left = Number(D.YawLeft)
        this.form.yaw_right =Number(D.YawRight)
        this.form.pitch_up = Number(D.PitchUp)
        this.form.pitch_down = Number(D.PitchDown)
        this.form.draw_en = Number(D.drawEn)
        this.form.installSelfCheck = Number(D.installSelfCheck ?? D.install_self_check ?? 0)

        const map = {
          call: D.call_alarm,
          smoking: D.smoke_alarm,
          eyes_closed: D.close_eys_alarm,
          close_eys_serious: D.close_eys_serious_alarm,
          yawning: D.yawn_alarm,
          yawn_serious: D.yawn_serious_alarm,
          distracted: D.distract_driving_alarm,
          no_driver: D.driver_abnormal_alarm,
          infrared: D.ir_blocking_alarm,
          seat_belt: D.seatbelt_unfastened_alarm,
          camera_cover: D.lens_covered_alarm,
          fatigue_driving: D.fatigue_driving_alarm,
        }
        const parseLinkage = (src) => {
          if (!src) return null
          return {
            start_record: Number(src.record ?? 0),
            voice_broadcast: Number(src.linkBuzzer ?? 0),
            preview_mode: this.codeToPreviewMode(src.linkPreviewMode),
            video_lock: this.maskToChannels(Number(src.linkLockChn ?? 0)),
            video_upload: this.maskToChannels(Number(src.linkUploadChn ?? 0)),
            link_output: Number(src.linkOutput ?? 0) === 1,
            snapshot_upload: this.maskToChannels(Number(src.linkSnapChn ?? 0)),
            TimeOut1: String(src.TimeOut1 ?? src.OutputHold),
            preview: this.maskToChannels(Number(src.PreviewChn ?? 0)),
          }
        }
        this.form.rows = this.form.rows.map((r) => {
          const src = map[r.key]
          if (!src) return r
          const linkage = {
            ...r,
            state: Number(src.enable ?? 0),
            threshold: Number(src.limit ?? r.threshold ?? 0),
            interval: Number(src.delay ?? r.interval ?? 0),
            pre_record: Number(src.holdtime ?? r.pre_record ?? 0),
            keeptime: Number(src.keeptime ?? 0),
            alarm_trigger: Number(src.AlmTrigerHoldTime ?? r.alarm_trigger ?? 0.5),
            linkage: parseLinkage(src),
          }
          return linkage
        })
        this.saveOriginalFormData()
      },
      openLinkage(item, index) {
        this.activeRowIndex = index
        const saved = item.linkage || {}
        this.linkageForm = {
          start_record: saved.start_record ?? 0,
          voice_broadcast: saved.voice_broadcast ?? 0,
          preview_mode: saved.preview_mode ?? 'Model2',
          video_lock: Array.isArray(saved.video_lock) ? [...saved.video_lock] : [],
          video_upload: Array.isArray(saved.video_upload) ? [...saved.video_upload] : [],
          link_output: saved.link_output ?? false,
          snapshot_upload: Array.isArray(saved.snapshot_upload) ? [...saved.snapshot_upload] : [],
          TimeOut1: saved.TimeOut1 ?? saved.TimeOut1,
          preview: Array.isArray(saved.preview) ? [...saved.preview] : [],
        }
        this.linkageModal = true
      },
      saveLinkage() {
        if (this.activeRowIndex !== null) {
          const row = this.form.rows[this.activeRowIndex]
          row.linkage = JSON.parse(JSON.stringify(this.linkageForm))
        }
        this.linkageModal = false
      },
      maskToChannels(mask) {
        const channels = []
        Object.entries(this.channelMap).forEach(([ch, value]) => {
          if (mask & value) {
            channels.push(ch)
          }
        })
        return channels
      },
      codeToPreviewMode(code) {
        return `Model${Number(code)}`
      },
      isFieldEnabled(rowKey, fieldName) {
        const config = this.currentDeviceConfig[rowKey]
        if (!config) return true
        return config[fieldName] !== false
      },
      chageCustomProfile() {
        this.form.profile = this.defaultProfile
        this.form.profile_name = 'Custom'
      },
      getChangedFields() {
        if (!this.originalFormData) return null

        const changes = []
        
        const formatValue = (value, fieldName) => {
          if (fieldName === 'state') {
            const option = this.stateOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'preview_mode') {
            const option = this.previewModeOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'installation') {
            const option = this.installOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'distraction_angle') {
            const option = this.angleOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'draw_en') {
            const option = this.aiFrameOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'installSelfCheck') {
            const option = this.installSelfCheckOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'start_record') {
            const option = this.stateOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'voice_broadcast') {
            const option = this.stateOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'video_channel') {
            return value
          }
          if (Array.isArray(value)) {
            return value.sort().join(',')
          }
          return value
        }
        
        const compareObjects = (original, current, path = '') => {
          const excludedKey = ['profile', 'profile.id']

          for (const key in current) {
            const currentPath = path ? `${path}.${key}` : key

            if (excludedKey.includes(currentPath)) continue
            
            if (typeof current[key] === 'object' && current[key] !== null && !Array.isArray(current[key])) {
              if (original[key]) {
                compareObjects(original[key], current[key], currentPath)
              }
            } else if (Array.isArray(current[key])) {
              if (JSON.stringify(original[key]) !== JSON.stringify(current[key])) {
                const maxLength = Math.max(original[key]?.length || 0, current[key].length)
                for (let i = 0; i < maxLength; i++) {
                  const origItem = original[key]?.[i]
                  const currItem = current[key][i]
                  
                  if (typeof currItem === 'object' && currItem !== null) {
                    for (const prop in currItem) {
                      if (prop === 'type' || prop === 'key') continue
                      
                      // Handle nested objects like linkage
                      if (typeof currItem[prop] === 'object' && currItem[prop] !== null && !Array.isArray(currItem[prop])) {
                        const origNested = origItem?.[prop]
                        const currNested = currItem[prop]
                        
                        if (JSON.stringify(origNested) !== JSON.stringify(currNested)) {
                          // Compare each nested property
                          for (const nestedKey in currNested) {
                            if (JSON.stringify(origNested?.[nestedKey]) !== JSON.stringify(currNested[nestedKey])) {
                              const fieldPath = `${currItem.key}.${prop}.${nestedKey}`
                              changes.push({
                                field: fieldPath,
                                before: formatValue(origNested?.[nestedKey], nestedKey).toString(),
                                after: formatValue(currNested[nestedKey], nestedKey).toString()
                              })
                            }
                          }
                        }
                      } else if (JSON.stringify(origItem?.[prop]) !== JSON.stringify(currItem[prop])) {
                        const fieldPath = `${currItem.key}.${prop}`
                        changes.push({
                          field: fieldPath,
                          before: formatValue(origItem?.[prop], prop).toString(),
                          after: formatValue(currItem[prop], prop).toString()
                        })
                      }
                    }
                  }
                }
              }
            } else if (JSON.stringify(original[key]) !== JSON.stringify(current[key])) {
              // Value has changed
            changes.push({
              field: currentPath,
                before: formatValue(original[key], key),
                after: formatValue(current[key], key)
              })
            }
          }
        }

        compareObjects(this.originalFormData, this.form)
        return changes
      }
    },
    watch: {
      modal(newVal) {
        if (newVal) {
          this.initFromInitial()
        } 
      },
      dmsInitialValue: {
        handler() {
          if (this.modal) this.initFromInitial()
        },
        deep: true,
      },
    },
  }
</script>

<template>
  <div>
    <b-modal
      v-model="showModal"
      class="mc-modal"
      id="modal-form-dms-vss"
      title="DMS setting"
      size="xl"
      centered
      :hide-header-close="true"
      no-close-on-backdrop
      hide-footer
    >
      <div class="card-body mc-modal__filter p-2">
        <b-form @submit.stop.prevent>
          <b-row class="mb-2">
            <b-col cols="12" md="4" class="mb-2">
              <label class="mt-1">DMS Profile</label>
              <v-select
                v-model="form.profile"
                :options="filteredProfiles"
                label="profile_name"
                :reduce="v => v.id"
                :clearable="false"
                placeholder="Select profile"
                @input="selectProfile"
              />
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="12" md="3" class="mb-2">
              <label class="mt-1">Video channel</label>
              <v-select
                v-model="form.video_channel"
                :options="channelOptions"
                label="name"
                :reduce="v => v.id"
                placeholder="Select channel"
                :clearable="false"
                @input="chageCustomProfile"
              />
            </b-col>
            <b-col cols="12" md="3" class="mb-2">
              <label class="mt-1">Installation</label>
              <v-select
                v-model="form.installation"
                :options="installOptions"
                label="name"
                :reduce="v => v.id"
                placeholder="Select installation"
                :clearable="false"
                @input="chageCustomProfile"
              />
            </b-col>
            <b-col cols="12" md="3" class="mb-2">
              <label class="mt-1">Distraction angle setting</label>
              <v-select
                v-model="form.distraction_angle"
                :options="angleOptions"
                label="name"
                :reduce="v => v.id"
                placeholder="Select angle"
                :clearable="false"
                @input="chageCustomProfile"
              />
            </b-col>
            <b-col cols="12" md="3" class="mb-2">
              <label class="mt-1">AI frame</label>
              <v-select
                v-model="form.draw_en"
                :options="aiFrameOptions"
                label="name"
                :reduce="v => v.id"
                placeholder="Select AI frame"
                :clearable="false"
                @input="chageCustomProfile"
              />
            </b-col>
            <b-col cols="12" md="3" class="mb-2">
              <label class="mt-1">Install self check</label>
              <v-select
                v-model="form.installSelfCheck"
                :options="installSelfCheckOptions"
                label="name"
                :reduce="v => v.id"
                placeholder="Select install self check"
                :clearable="false"
                @input="chageCustomProfile"
              />
            </b-col>
          </b-row>
          <b-row v-if="form.distraction_angle !== 2" class="mb-2">
            <b-col cols="12" md="3" class="mb-2">
              <label class="mt-1">Distracted driving angle Right</label>
              <b-form-input
                v-model.number="form.yaw_right"
                type="number"
                min="0"
                @keypress="onlyNumber"
                @input="chageCustomProfile"
              />
            </b-col>
            <b-col cols="12" md="3" class="mb-2">
              <label class="mt-1">Distracted driving angle Left</label>
              <b-form-input
                v-model.number="form.yaw_left"
                type="number"
                min="0"
                @keypress="onlyNumber"
                @input="chageCustomProfile"
              />
            </b-col>
            <b-col cols="12" md="3" class="mb-2">
              <label class="mt-1">Distracted driving angle Lower</label>
              <b-form-input
                v-model.number="form.pitch_down"
                type="number"
                min="0"
                @keypress="onlyNumber"
                @input="chageCustomProfile"
              />
            </b-col>
            <b-col cols="12" md="3" class="mb-2">
              <label class="mt-1">Distracted driving angle Upper</label>
              <b-form-input
                v-model.number="form.pitch_up"
                type="number"
                min="0"
                @keypress="onlyNumber"
                @input="chageCustomProfile"
              />
            </b-col>
          </b-row>

          <div class="table-responsive my-2 border border-1">
            <b-table
              small
              show-empty
              :items="form.rows"
              :fields="fields"
              head-variant="light"
            >
              <template #cell(type)="{ item }">
                <strong>{{ item.type }}</strong>
              </template>
              <template #cell(state)="{ item }">
                <v-select
                  v-model="item.state"
                  :options="stateOptions"
                  label="name"
                  :reduce="v => v.id"
                  placeholder="State"
                  :clearable="false"
                  :disabled="!isFieldEnabled(item.key, 'state')"
                  @input="chageCustomProfile"
                />
              </template>
              <template #cell(threshold)="{ item }">
                <b-form-input
                  v-model.number="item.threshold"
                  type="number"
                  min="0"
                  @keypress="onlyNumber"
                  @input="chageCustomProfile"
                  :disabled="!isFieldEnabled(item.key, 'threshold')"
                />
              </template>
              <template #cell(alarm_trigger)="{ item }">
                <b-form-input
                  v-model.number="item.alarm_trigger"
                  type="number"
                  min="0"
                  @keypress="onlyNumber"
                  @input="chageCustomProfile"
                  :disabled="!isFieldEnabled(item.key, 'alarm_trigger')"
                />
              </template>
              <template #cell(keeptime)="{ item }">
                <b-form-input
                  v-model.number="item.keeptime"
                  type="number"
                  min="0"
                  @keypress="onlyNumber"
                  @input="chageCustomProfile"
                  :disabled="!isFieldEnabled(item.key, 'keeptime')"
                />
              </template>
              <template #cell(alarm_linkage)="{ item, index }">
                <b-button 
                  :variant="isFieldEnabled(item.key, 'alarm_linkage') ? 'outline-primary' : 'secondary'" 
                  size="sm" 
                  @click="openLinkage(item, index)" :disabled="!isFieldEnabled(item.key, 'alarm_linkage')">
                  Alarm linkage
                </b-button>
              </template>
              <template #cell(interval)="{ item }">
                <b-form-input
                  v-model.number="item.interval"
                  type="number"
                  min="0"
                  @keypress="onlyNumber"
                  @input="chageCustomProfile"
                  :disabled="!isFieldEnabled(item.key, 'interval')"
                />
              </template>
              <template #cell(pre_record)="{ item }">
                <b-form-input
                  v-model.number="item.pre_record"
                  type="number"
                  min="0"
                  @keypress="onlyNumber"
                  @input="chageCustomProfile"
                  :disabled="!isFieldEnabled(item.key, 'pre_record')"
                />
              </template>
            </b-table>
          </div>
        </b-form>
      </div>

      <template>
        <div class="d-flex justify-content-between align-items-center mx-2">
          <p v-if="!this.dmsInitialValue" class="text-danger">Device offline cannot be saved</p>
          <div :class="{ 'ms-auto': this.dmsInitialValue }">
            <b-button variant="outline-primary" @click="closeModal" :disabled="loading" class="me-3">
              Batal
            </b-button>
          <b-button @click="openConfirm" variant="primary" :disabled="loading || !this.dmsInitialValue">
              <b-spinner v-if="loading" small type="grow"></b-spinner>
              {{ loading ? 'Loading...' : 'Simpan' }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="linkageModal"
      class="mc-modal"
      id="modal-alarm-linkage-dms-vss"
      title="Alarm linkage"
      size="xl"
      centered
      hide-footer
    >
      <div class="card-body p-2">
        <b-row>
          <b-col cols="12" md="6">
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Start record</b-col>
              <b-col cols="7">
                <v-select
                  v-model="linkageForm.start_record"
                  :options="stateOptions"
                  label="name"
                  :reduce="v => v.id"
                  :clearable="false"
                  @input="chageCustomProfile"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Preview mode</b-col>
              <b-col cols="7">
                <v-select
                  v-model="linkageForm.preview_mode"
                  :options="previewModeOptions"
                  label="name"
                  :reduce="v => v.id"
                  :clearable="false"
                  @input="chageCustomProfile"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Video Upload</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox v-for="ch in channelOptions" :key="'up-'+ch.id" v-model="linkageForm.video_upload" :value="ch.id" class="me-2" @input="chageCustomProfile">
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Out1 output time</b-col>
              <b-col cols="7">
                <b-form-input v-model="linkageForm.TimeOut1" @input="chageCustomProfile" />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Preview</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox v-for="ch in channelOptions" :key="'prev-'+ch.id" v-model="linkageForm.preview" :value="ch.id" class="me-2" @input="chageCustomProfile">
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Voice broadcast</b-col>
              <b-col cols="7">
                <v-select
                  v-model="linkageForm.voice_broadcast"
                  :options="stateOptions"
                  label="name"
                  :reduce="v => v.id"
                  :clearable="false"
                  @input="chageCustomProfile"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Video lock</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox v-for="ch in channelOptions" :key="'lock-'+ch.id" v-model="linkageForm.video_lock" :value="ch.id" class="me-2" @input="chageCustomProfile">
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Link output</b-col>
              <b-col cols="7" class="d-flex">
                <b-form-checkbox v-model="linkageForm.link_output" @input="chageCustomProfile">
                    <label class="ms-1">OUT1</label>
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Snapshot and Upload</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox v-for="ch in channelOptions" :key="'snap-'+ch.id" v-model="linkageForm.snapshot_upload" :value="ch.id" class="me-2" @input="chageCustomProfile">
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div class="text-end mt-3">
          <b-button variant="primary" @click="saveLinkage">Close</b-button>
        </div>
      </div>
    </b-modal>

    <confirmation
      v-if="modalConfirm"
      :modal.sync="modalConfirm"
      message="Yakin ingin menyimpan pengaturan DMS?"
      @confirmed="afterConfirm"
      centered
    />

    <b-modal
      v-model="modalUnsavedConfirm"
      class="mc-modal"
      title="Konfirmasi"
      centered
      hide-footer
    >
      <p>Perubahan belum disimpan. Apakah Anda ingin menyimpan perubahan?</p>
      <div class="text-end">
        <b-button variant="outline-secondary" @click="closeModalWithoutSaving" class="me-2">
          Tutup tanpa menyimpan
        </b-button>
        <b-button variant="primary" :disabled="!this.dmsInitialValue" @click="saveAndCloseModal">
          Simpan
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
